<form #searchForm="ngForm" class="search-redirect-form" (ngSubmit)="onSubmit()">
  <input type="submit" value="search">
  <input type="text" name="searchText" placeholder="Search rules" [(ngModel)]="searchText" required>
</form>